import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4752907d&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style0 from "./index.vue?vue&type=style&index=0&id=4752907d&prod&lang=css"
import style1 from "./index.vue?vue&type=style&index=1&id=4752907d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4752907d",
  null
  
)

export default component.exports